// extracted by mini-css-extract-plugin
module.exports = {"root":"MarketSelectorView_root__3D8vM","label":"MarketSelectorView_label__2aWXp","dropdown":"MarketSelectorView_dropdown__3Md1p"};